//TODO: GROW-2738 Clean up jade roll out clean up Gen3 clean up

import { useEffect, useMemo, useState } from 'react';

import useJapaneseRegionalSite from '../experiments/useJapaneseRegionalSite';
import useJadeRollout from './useJadeRollout';

export enum ImageExperience {
  JAPANESE = 'japanese',
  JADE = 'jade',
  DEFAULT = 'default',
}

interface ImageExperienceProps {
  japaneseImgObj?: { img: string; alt: string };
  jadeImgObj: { img: string; alt: string };
  defaultImgObj: { img: string; alt: string };
}

export const useImageExperience = ({
  japaneseImgObj,
  jadeImgObj,
  defaultImgObj,
}: ImageExperienceProps): { img: string; alt: string } => {
  const isJapaneseRegionalSite = useJapaneseRegionalSite();
  const isJade = useJadeRollout();
  const [img, setImg] = useState(defaultImgObj);

  const experience = useMemo(() => {
    if (isJapaneseRegionalSite) {
      return ImageExperience.JAPANESE;
    } else if (isJade) {
      return ImageExperience.JADE;
    } else {
      return ImageExperience.DEFAULT;
    }
  }, [isJapaneseRegionalSite, isJade]);

  useEffect(() => {
    if (experience === ImageExperience.JAPANESE && japaneseImgObj) {
      setImg(japaneseImgObj);
    } else if (experience === ImageExperience.JADE) {
      setImg(jadeImgObj);
    } else {
      setImg(defaultImgObj);
    }
  }, [experience]);

  return img;
};
